export enum Workflow {
    RETRY_WORKFLOW_START = "RETRY_WORKFLOW_START",
    RETRY_WORKFLOW_SUCCESS = "RETRY_WORKFLOW_SUCCESS",
    RETRY_WORKFLOW_FAIL = "RETRY_WORKFLOW_FAIL",
}